import { useTranslation } from 'react-i18next'
import type { ReconciliationLine } from '../types'

function fmt(ts: string): string {
  return new Date(ts).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' })
}

export function PriceListPanel({ line }: { line: ReconciliationLine }) {
  const { t } = useTranslation()

  if (!line.price_list_id) return null

  const fmt2 = (v: number | null) =>
    v !== null ? v.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) : '—'

  const sourceLabel = line.price_list_source_format === 'excel' ? 'Excel' : 'XML'
  const notFound    = line.not_in_price_list
  const bgClass     = notFound ? 'bg-red-50'    : 'bg-amber-50'
  const titleClass  = notFound ? 'text-red-800' : 'text-amber-800'
  const title       = notFound
    ? t('price_list_panel.title_not_found')
    : t('price_list_panel.title_found')

  return (
    <div className={`border-t border-gray-200 ${bgClass} px-4 py-3`}>
      <p className={`text-xs font-semibold ${titleClass} uppercase tracking-wide mb-2`}>{title}</p>
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs">
        <span className="text-gray-500">{t('price_list_panel.label_price_list')}</span>
        <span className="font-medium text-gray-800">{line.price_list_name ?? '—'}</span>
        <span className="text-gray-500">{t('price_list_panel.label_supplier_gln')}</span>
        <span className="font-mono text-gray-700">{line.price_list_supplier_gln ?? '—'}</span>
        <span className="text-gray-500">{t('price_list_panel.label_buyer_gln')}</span>
        <span className="font-mono text-gray-700">{line.price_list_buyer_gln ?? '—'}</span>
        <span className="text-gray-500">{t('price_list_panel.label_source')}</span>
        <span className="text-gray-700">{sourceLabel}</span>
        {line.price_list_created_at && (
          <>
            <span className="text-gray-500">{t('price_list_panel.label_uploaded')}</span>
            <span className="text-gray-700">{fmt(line.price_list_created_at)}</span>
          </>
        )}
      </div>
      {!notFound && (
        <div className="mt-2 flex gap-x-8 text-xs">
          <div>
            <span className="text-gray-500">{t('price_list_panel.label_gross_price')} </span>
            <span className="font-mono font-semibold text-gray-800">{fmt2(line.agreed_gross_price)}</span>
          </div>
          <div>
            <span className="text-gray-500">{t('price_list_panel.label_net_price')} </span>
            <span className="font-mono font-semibold text-gray-800">{fmt2(line.agreed_net_price)}</span>
          </div>
        </div>
      )}
      {notFound && (
        <p className="mt-1.5 text-xs text-red-600">
          {t('price_list_panel.article_not_found')}
        </p>
      )}
    </div>
  )
}
